
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "amfe-flexible"
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/base.css'
import Api from './api/index';
import { Message } from 'element-ui'
import 'amfe-flexible'
Vue.prototype.$axios = Api;
Vue.prototype.$Message = Message;
Vue.prototype.$inserted = function transformTimestamp(time) {
  let a = new Date(time).getTime();
  const date = new Date(a);
  const Y = date.getFullYear() + '-';
  const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '  ';
  const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
  // const s = date.getSeconds(); // 秒
  const dateString = Y + M + D + h + m;
  // console.log('dateString', dateString); // > dateString 2021-07-06 14:23
  return dateString;
};

const bus = new Vue()
Vue.prototype.$bus = bus;
Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
